import ReactDOM from 'react-dom/client'
import type { CartDrawerData } from '@velasca/types'
import { parseJSONSafe } from '@velasca/utils/parse-json-safe'
import { HomePageAppWrapper } from './HomePageAppWrapper'

interface HomepageAppParams {
  heroData: any
  homePageEl: HTMLElement | null
  cartDrawerData: CartDrawerData
  headerEl: HTMLElement | null
  headerData: any
  promotionalBannerData: any
  categoriesBlocksData: any
}

export const renderHomePageApp = ({
  heroData,
  homePageEl,
  cartDrawerData,
  headerEl,
  headerData,
  promotionalBannerData,
  categoriesBlocksData,
}: HomepageAppParams) => {
  if (homePageEl) {
    //#region CollectionFocusBlock
    const collectionFocusSlidesDataEl = document.querySelector<HTMLElement>(
      '#collecion-focus-block-data',
    )
    const collectionFocusSlidesData = collectionFocusSlidesDataEl
      ? parseJSONSafe(collectionFocusSlidesDataEl.innerText, {
          fallbackValue: [],
        })
      : []
    //#endregion

    //#region CarouselsStack
    const carouselsStackDataEl = document.querySelector<HTMLElement>(
      '#collections-slider-block-data',
    )
    const carouselsStackData = carouselsStackDataEl
      ? parseJSONSafe(carouselsStackDataEl.innerText, { fallbackValue: [] })
      : {}
    //#endregion

    //#region AboutUsBlock
    const aboutUsDataEl = document.querySelector<HTMLElement>(
      '#about-us-block-data',
    )
    const aboutUsData = aboutUsDataEl
      ? parseJSONSafe(aboutUsDataEl.innerText, { fallbackValue: {} })
      : {}
    //#endregion

    //#region BottegasBlock
    const bottegasBlockEl = document.querySelector<HTMLElement>(
      '#bottegas-block-data',
    )
    const bottegasBlockData = bottegasBlockEl
      ? parseJSONSafe(bottegasBlockEl.innerText, { fallbackValue: {} })
      : {}
    //#endregion

    //#region RedirectBlock
    const redirectBlockEl = document.querySelector<HTMLElement>(
      '#redirect-block-data',
    )
    const redirectBlockData = redirectBlockEl
      ? parseJSONSafe(redirectBlockEl.innerText, { fallbackValue: {} })
      : {}
    //#endregion

    //#region InstagramFeed
    const instagramFeedEl = document.querySelector<HTMLElement>(
      '#instagram-feed-data',
    )
    const instagramFeedData = instagramFeedEl
      ? parseJSONSafe(instagramFeedEl.innerText, { fallbackValue: {} })
      : {}
    //#endregion

    ReactDOM.createRoot(homePageEl).render(
      <HomePageAppWrapper
        heroData={heroData}
        collectionFocusSlidesData={collectionFocusSlidesData}
        carouselsStackData={carouselsStackData}
        aboutUsData={aboutUsData}
        bottegasBlockData={bottegasBlockData}
        redirectBlockData={redirectBlockData}
        cartDrawerData={cartDrawerData}
        headerEl={headerEl}
        headerData={headerData}
        promotionalBannerData={promotionalBannerData}
        categoriesBlocksData={categoriesBlocksData}
        instagramFeedData={instagramFeedData}
      />,
    )
  }
}
